"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologyDefinition = void 0;
const static_service_1 = require("@wix/static-service");
exports.TopologyDefinition = (0, static_service_1.defineStaticService)('viewer-core/viewer-service-topology');
//# sourceMappingURL=index.js.map